<template>
  <Transition
      enter-active-class="transition transform ease-out duration-300"
      enter-from-class="translate-y-full opacity-0"
      enter-to-class="translate-y-0 opacity-100"
      leave-active-class="transition transform ease-in duration-250"
      leave-from-class="translate-y-0 opacity-100"
      leave-to-class="translate-y-full opacity-0"
  >
    <footer
        v-if="open"
        class="sticky inset-x-0 z-40 w-full border-t border-border bg-background text-muted-foreground font-sans pb-safe max-md:border-border/50 max-md:bg-background/80 max-md:backdrop-blur-md max-md:shadow-lg"
    >
      <div class="max-w-screen-xl mx-auto px-4 py-4 md:px-6">
        <div class="flex flex-col md:flex-row items-center justify-between gap-4">
          <div class="flex flex-wrap items-center justify-center gap-2">
            <!-- Contact link -->
            <a
                href="mailto:info@betpic.com"
                class="px-3 py-1.5 rounded-lg bg-secondary/50 hover:bg-secondary transition text-xs font-medium"
            >
              Contact Us
            </a>

            <!-- Privacy Policy button -->
            <button
                @click="showPrivacy = true"
                class="px-3 py-1.5 rounded-lg bg-secondary/50 hover:bg-secondary transition text-xs font-medium"
            >
              Privacy
            </button>

            <!-- Cookie Policy button -->
            <button
                @click="showCookies = true"
                class="px-3 py-1.5 rounded-lg bg-secondary/50 hover:bg-secondary transition text-xs font-medium"
            >
              Cookies
            </button>
          </div>

          <span class="text-[10px] md:text-xs opacity-60 font-medium">© {{ currentYear }} {{ brandName }}. Powered by Voxbet technology.</span>
        </div>
      </div>

      <!-- Modals -->
      <PrivacyPolicyModal v-model:isOpen="showPrivacy" />
      <CookiePolicyModal v-model:isOpen="showCookies" />
    </footer>
  </Transition>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import PrivacyPolicyModal from '@/components/app/privacy/PrivacyPolicyModal.vue'
import CookiePolicyModal from '@/components/app/cookies/CookiePolicyModal.vue'
import { closeAllModalsEventBus } from '@/utils/eventBus'

defineProps<{
  open: boolean
}>()

const route = useRoute()
const currentYear = ref(new Date().getFullYear())
const showPrivacy = ref(false)
const showCookies = ref(false)

const brandName = computed(() => {
  if (route.path.startsWith('/betpic')) {
    return 'BetPic'
  } else if (route.path.startsWith('/odds')) {
    return 'Ask Odds'
  } else {
    return 'Ask Bookmaker'
  }
})

closeAllModalsEventBus.on(() => {
  showPrivacy.value = false
  showCookies.value = false
})
</script>